import { Box, Tab, Tabs, Typography, useTheme } from "@mui/material"
import { styled } from '@mui/material/styles'
import { routes } from "../../routes/Routes"
import PreviewOutlinedIcon from '@mui/icons-material/PreviewOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'

const PageTabs = styled(Tabs)({
  height: '60px'
})

const PageTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  fontSize: '16px',
  height: '60px',
  textTransform: 'none',
  letterSpacing: '0.2px',
  fontWeight: 400,
  color: theme.palette.text.primary,
  fontFamily: 'Poppins',
  '&:hover': {
    color: theme.palette.primary.main,
  },
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  }
}))


export default function AppNav(props) {
  const {
    disabled,
    page,
    visible,
    handleToPage,
    viewerIconDisabled,
    handleClickMenuItem
  } = props

  const theme = useTheme()

  const handleChangeTab = (event, newValue) => {
    handleToPage(newValue)
  }

  const onClickMenuItem = page => () => {
    handleClickMenuItem(page)
  }

  const pageValue =
    page === routes.home ||
      page === routes.viewer ? page : false

  if (!visible)
    return ''

  return (
    <>
      <PageTabs
        value={pageValue}
        onChange={handleChangeTab}
        TabIndicatorProps={{
          style: {
            transition: pageValue ? 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'none'
          }
        }}
        sx={{
          [theme.breakpoints.down('lg')]: {
            display: "none"
          }
        }}
      >
        <PageTab
          value={routes.home}
          label="Home"
          disabled={disabled}
        />
        <PageTab
          value={routes.viewer}
          label="Viewer"
          disabled={disabled}
        />
      </PageTabs>

      <Box
        sx={{
          [theme.breakpoints.up('lg')]: { display: "none" },
          pl: 3,
          pt: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
          color={page === routes.home ? 'primary' : ""}
          onClick={onClickMenuItem(routes.home)}
          sx={{
            display: "inline-flex",
            "&:hover": {
              color: theme.palette.primary.light,
            },
            alignItems: "center",
            gap: 1
          }}
        >
          <HomeOutlinedIcon sx={{ mr: 1 }} />
          Home
        </Typography>

        <Typography
          onClick={viewerIconDisabled ? null : onClickMenuItem(routes.viewer)}
          disabled={viewerIconDisabled}
          sx={{
            "&:hover": {
              color: viewerIconDisabled ? "" : theme.palette.primary.light,
            },
            color: viewerIconDisabled ? theme.palette.text.disabled : page === routes.viewer ? theme.palette.primary.main : "",
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <PreviewOutlinedIcon sx={{ mr: 1 }} />
          Configurazione
        </Typography>

      </Box>
    </>
  )
}
